import { auth } from "@/config/firebase";
import { Role } from "@/types/user";
import storage from "@/utils/storage";
import { User as FirebaseUser, UserInfo } from "firebase/auth";
import { create } from "zustand";

interface User {
    displayName: string | null;
    photoURL: string | null;
    email: string | null;
    emailVerified: boolean;
    providerData: UserInfo[];
    role: Role;
    authenticated: boolean;
}

interface Actions {
    login(): void;
    logout(): void;
    update(): Promise<void>;
    setState(state: Partial<User>): void;
}

const initialState: User = {
    displayName: null,
    photoURL: null,
    email: null,
    emailVerified: false,
    providerData: [],
    role: "ADMIN",
    authenticated: false,
};

const useUser = create<User & Actions>(set => ({
    ...initialState,
    login: () => {
        const user = auth.currentUser as FirebaseUser;
        storage.setItem("lastLogin", Date.now());
        set({ ...user, authenticated: true });
    },
    logout: () => {
        storage.removeItem("lastLogin");
        storage.removeItem("oid");
        set(initialState);
    },
    update: async () => {
        const user = auth.currentUser as FirebaseUser;
        await user.reload();

        const { displayName, photoURL, providerData } = user;

        set({ displayName, photoURL, providerData });
    },
    setState: state => set({ ...state }),
}));

export type { User };
export default useUser;
